import { render, staticRenderFns } from "./revocation.vue?vue&type=template&id=02c80e42&scoped=true&"
import script from "./revocation.vue?vue&type=script&lang=js&"
export * from "./revocation.vue?vue&type=script&lang=js&"
import style0 from "./revocation.vue?vue&type=style&index=0&id=02c80e42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c80e42",
  null
  
)

export default component.exports